import React from "react";
import { PaymentType } from "univapay-node";

import { Content } from "../common/FormConfirm";

export const ContentPaidy = () => <Content paymentType={PaymentType.PAIDY} />;

export default ContentPaidy;
